// utils/logger.js
const isBrowser = typeof window !== "undefined";

const isLocalhost = isBrowser && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "::1");

/**
 * Basic logger with auto-disable in production
 */
const logger = {
  info: (...args) => {
    if (isLocalhost) {
      console.log(`[INFO - ${new Date().toISOString()}]`, ...args);
    }
  },

  warn: (...args) => {
    if (isLocalhost) {
      console.warn(`[WARN - ${new Date().toISOString()}]`, ...args);
    }
  },

  error: (...args) => {
    // Always log errors (or change if you want)
    console.error(`[ERROR - ${new Date().toISOString()}]`, ...args);

    // Example: send to server if NOT localhost
    if (!isLocalhost) {
      // fetch("/api/log-error", { method: "POST", body: JSON.stringify(args) })
    }
  },

  // Optional debug logger
  debug: (...args) => {
    if (isLocalhost) {
      console.log(`[DEBUG - ${new Date().toISOString()}]`, ...args);
    }
  },
};

export default logger;
